import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { UiButton, UiIcon } from 'ui-components';

const FeedbackModalThanks = ({ handleStep, toggleHamburger }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  /* رفتن به لیست تیکت‌ها */
  const handleTicketBtn = (event) => {
    // اگر در همان صفحه لیست تیکت‌ها بودیم ناچاریم صفحه را ریلود کنیم
    if (location.pathname === '/support/tickets') {
      return location.reload();
    }
    navigate('/support/tickets');
    toggleHamburger(event);
    setTimeout(() => {
      handleStep('step_1');
    }, 500);
  };

  return (
    <>
      <div className='feedback-component-header step-header'>
        <div className='header-info'>
          <UiIcon
            className='mr-0'
            icon='ri-arrow-right-s-line'
            size={20}
            color='#454545'
            onClick={() => handleStep('step_1')}
          />
          <span className='label'>{t('support:pageTitle')}</span>
        </div>
        <UiIcon
          className='header-close'
          icon='ri-close-circle-fill'
          size={20}
          color='#9CAEBB'
          onClick={toggleHamburger}
        />
      </div>
      <div className='feedback-component-body'>
        <div className='body-support mt-8 text-justify'>
          <div>{t('support:yourFeedbackRegistered')}</div>
          <div className='mt-10 mb-20'>
            {t('support:thankYouForHelpingUsToImprove')}
          </div>
          <div className='button--wrapper flex col'>
            <UiButton
              variant='outlined'
              color='primary'
              fullWidth
              onClick={handleTicketBtn}
            >
              {t('support:tickets')}
            </UiButton>
          </div>
        </div>
      </div>
    </>
  );
};

FeedbackModalThanks.propTypes = {
  handleStep: PropTypes.func,
  toggleHamburger: PropTypes.func,
};

export default FeedbackModalThanks;
